import AccountOverviewCard from '../../../lib/AccountOverviewCard/AccountOverviewCard';
import {pushViewAction} from '../../../redux/actions/Actions';
import {appStore} from '../../../redux/createStore';
import {formatCurrency} from '../../../utils/util';
import SkeletonLoader from '../../skeletonLoader/SkeletonLoader';

import {Typography, Button} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './AccountOverview.css';
import {connect} from 'react-redux';

const AccountOverview = (props) => {
  const {t} = useTranslation();
  const [totalExposure, setTotalExposure] = React.useState(null);

  React.useEffect(() => {
    if (props.productOverview && typeof props.productOverview === 'object') {
      setTotalExposure(
        Object.values(props.productOverview).reduce((total, product) => {
          return total + (product.totalOutstandingBalance || 0);
        }, 0)
      );
    }
  }, [props.productOverview]);

  const renderAccountOverviewCard = (productOverview) => {
    return Object.keys(productOverview).map((productType) => {
      const productDetails = productOverview[productType];

      return (
        <AccountOverviewCard
          key={productType}
          productType={productType}
          productDetails={productDetails}
        />
      );
    });
  };
  return (
    <div className="account-overview-container">
      <div className="account-overview-header">
        <div className="account-overview-card-title">
          {t('ACCOUNT_OVERVIEW')}
        </div>
        <Button
          id="viewRequests"
          variant="text"
          onClick={() =>
            appStore.dispatch(
              pushViewAction(
                props.contractCounts > 1
                  ? 'contractDetailsOverview'
                  : 'contractDetails'
              )
            )
          }
        >
          {t('VIEW_DETAILS')}
        </Button>
      </div>
      {props.contractDetailsLoader ? (
        <SkeletonLoader componentName="nextInstallment" />
      ) : (
        <>
          <div>
            {t('TOTAL_EXPOSURE')}
            <Typography className={`value`} variant="label">
              {formatCurrency(totalExposure)}{' '}
            </Typography>
          </div>
          <div className="account-overview-card-container">
            {props.productOverview &&
              renderAccountOverviewCard(props.productOverview)}
          </div>
        </>
      )}
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    contractDetailsLoader: state.appStates.contractDetailsLoader,
    productOverview: state.appStates.contractDetails?.productOverview,
    contractCounts: state.appStates?.contractNumbers?.contractCounts,
  };
};
export default connect(mapStateToProps)(AccountOverview);
